import React from 'react';

import { useDebriefRouter } from 'ff/debrief/hooks';
import {
    useGetDebriefByTrackUUIDQuery,
    useGetDebriefStateQuery,
    useTriggerDebriefForTrackUUIDMutation,
} from 'ff/debrief/features/TracklogApi';

export function useCurrentDebrief() {
    const [isPolling, setIsPolling] = React.useState(false);

    const router = useDebriefRouter();

    const selectedTracklogId = router.routeParams.tracklogId;

    const {
        data: debrief,
        currentData: currentDebrief,
        ...debriefQueryStatus
    } = useGetDebriefByTrackUUIDQuery(selectedTracklogId, {
        skip: !selectedTracklogId,
    });

    const {
        currentData: debriefState,
        error: debriefStateError,
        ...debriefStateStatus
    } = useGetDebriefStateQuery(selectedTracklogId, {
        skip: !selectedTracklogId,
        pollingInterval: isPolling ? 2000 : undefined,
    });

    const [triggerDebriefForTrackId] = useTriggerDebriefForTrackUUIDMutation();

    const triggerDebrief = () => {
        triggerDebriefForTrackId(selectedTracklogId);
        setIsPolling(true);
    };

    React.useEffect(() => {
        if (
            debriefState?.status === 'COMPLETED' ||
            debriefState?.status === 'ERROR' ||
            debriefState?.status === 'SKIPPED' ||
            debriefState?.status === undefined
        ) {
            setIsPolling(false);
        } else if (
            debriefState?.status === 'PROCESSING' ||
            debriefState?.status === 'PENDING'
        ) {
            setIsPolling(true);
        } else {
            setIsPolling(false);
        }
    }, [debriefState?.status]);

    return {
        debrief: debrief,
        currentDebrief: currentDebrief,
        queryStatus: debriefQueryStatus,
        hasDebrief: debriefQueryStatus.isSuccess,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isUninitialized: (debriefStateError as any)?.status === 404,
        isLoading: debriefQueryStatus.isLoading || debriefStateStatus.isLoading,
        isPending: debriefState?.status === 'PENDING',
        isProcessing: debriefState?.status === 'PROCESSING',
        isSkipped: debriefState?.status === 'SKIPPED',
        isCompleted: debriefState?.status === 'COMPLETED',
        isError: debriefState?.status === 'ERROR',
        triggerDebrief,
    };
}
